export enum UserRole {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  REVENUE_MANAGER = 'revenue_manager',
  OPERATIONS = 'operations',
  OWNER = 'owner',
}

export interface User {
  id: string;
  /** Optional — username-only staff (Hotel Groups) have no email. */
  email: string | null;
  /** Per-tenant unique login handle for email-less staff; null for email users. */
  username?: string | null;
  role: UserRole;
  isActive: boolean;
  tenantId: string;
  firstName?: string | null;
  lastName?: string | null;
  /** True when the account has a one-time temp password and must set a real one. */
  mustChangePassword?: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
}

/**
 * Login accepts EITHER classic email login OR group-code + username login
 * (Hotel Groups — email-less staff). Exactly one mode per request; the two
 * member shapes are mutually exclusive (discriminated by which identity fields
 * are present). `groupCode` is the tenant `slug`.
 */
export type LoginCredentials =
  | { email: string; password: string }
  | { groupCode: string; username: string; password: string };

export interface RegisterCredentials {
  tenantName: string;
  tenantSlug: string;
  adminEmail: string;
  adminPassword: string;
  adminFirstName: string;
  adminLastName: string;
}

/**
 * Matches the actual backend AuthResponseDto shape:
 * { accessToken, refreshToken, user }
 */
export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  user: User;
}

/** @deprecated Use AuthTokens */
export interface TokenPair {
  accessToken: string;
  refreshToken: string;
}

export interface JwtPayload {
  sub: string;
  /**
   * Display/log-only in the token — identity is `sub` (user id). May be null for
   * username-only staff (Hotel Groups); it is never used to resolve the user.
   */
  email: string | null;
  role: UserRole;
  tenantId: string;
  iat?: number;
  exp?: number;
}
